import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject;

import React from 'react';
import styled from 'styled-components';
import { remCalc } from '@lux/helpers';
import Anchor from '../Anchor';
import Grid from '../Grid';
import Column from '../Column';
import List from '../List';
import ListItem from '../ListItem';
import Row from '../Row';
import Theme from '../../theme';
import Avatar from './Avatar';
import DesktopMenu from './DesktopMenu';
import Logo from './Logo';
import Search from './Search';
import ShoppingCart from './ShoppingCart';
import VeriSignLogo from './VeriSignLogo';
import IconLogin from '../../assets/svgs/header/login.svg';
var SCHeaderDesktop = styled.div.withConfig({
  displayName: "DesktopHeader__SCHeaderDesktop",
  componentId: "sc-664447-0"
})(["display:none;width:100%;z-index:99;", ";"], Theme.media.lg(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: block;\n  "]))));
var SCMenuItemList = styled(List).withConfig({
  displayName: "DesktopHeader__SCMenuItemList",
  componentId: "sc-664447-1"
})(["float:right;display:flex;align-items:center;height:100%;min-height:", ";"], remCalc(28));
var SCAnchorBlack = styled(Anchor).withConfig({
  displayName: "DesktopHeader__SCAnchorBlack",
  componentId: "sc-664447-2"
})(["color:", ";font-size:", ";display:block;&:not([disabled]){&:hover{color:", ";}}& svg{float:right;}"], Theme.colours.black, Theme.fonts.sizes.small, Theme.colours.black);
var SCFlexColumnAuto = styled(Column).withConfig({
  displayName: "DesktopHeader__SCFlexColumnAuto",
  componentId: "sc-664447-3"
})(["flex:1 0 auto;"]);
var SCFlexColumnAutoEnd = styled(Column).withConfig({
  displayName: "DesktopHeader__SCFlexColumnAutoEnd",
  componentId: "sc-664447-4"
})(["flex:0 0 auto;"]);
var SCMenuItemListPrimary = styled(List).withConfig({
  displayName: "DesktopHeader__SCMenuItemListPrimary",
  componentId: "sc-664447-5"
})(["padding-bottom:", ";> li{margin-left:0;}"], remCalc(6));
var RHSControlListItem = styled(ListItem).withConfig({
  displayName: "DesktopHeader__RHSControlListItem",
  componentId: "sc-664447-6"
})(["display:flex;align-items:center;&:first-child{margin:0;}"]);
var SCLogin = styled(Anchor).withConfig({
  displayName: "DesktopHeader__SCLogin",
  componentId: "sc-664447-7"
})(["display:block;"]);
var SCIconLogin = styled(IconLogin).withConfig({
  displayName: "DesktopHeader__SCIconLogin",
  componentId: "sc-664447-8"
})(["vertical-align:middle;"]);

var DesktopTopRHSMenuItems = function DesktopTopRHSMenuItems(_ref) {
  var baseUrl = _ref.baseUrl,
      items = _ref.items;
  return items.map(function (item, key) {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: key
    }, item.active ? /*#__PURE__*/React.createElement(SCAnchorBlack, {
      href: "" + baseUrl + item.href
    }, item.title) : /*#__PURE__*/React.createElement(SCAnchorBlack, {
      secondary: true,
      href: "" + baseUrl + item.href
    }, item.title));
  });
};

var DesktopRHSControls = function DesktopRHSControls(_ref2) {
  var baseUrl = _ref2.baseUrl,
      showSearch = _ref2.showSearch,
      showLoginButton = _ref2.showLoginButton,
      shoppingCartUrl = _ref2.shoppingCartUrl,
      isSearchActive = _ref2.isSearchActive,
      onSearchClick = _ref2.onSearchClick,
      loginUrl = _ref2.loginUrl,
      showVeriSignLogo = _ref2.showVeriSignLogo,
      showShoppingCart = _ref2.showShoppingCart,
      showAvatar = _ref2.showAvatar,
      avatarMenuItems = _ref2.avatarMenuItems;
  return /*#__PURE__*/React.createElement(SCMenuItemList, {
    isInline: true
  }, showSearch && /*#__PURE__*/React.createElement(RHSControlListItem, null, /*#__PURE__*/React.createElement(Search, {
    isActive: isSearchActive,
    onClick: onSearchClick
  })), showLoginButton && /*#__PURE__*/React.createElement(RHSControlListItem, null, /*#__PURE__*/React.createElement(SCLogin, {
    secondary: true,
    href: "" + baseUrl + loginUrl,
    ariaLabel: "Login Button"
  }, /*#__PURE__*/React.createElement(SCIconLogin, {
    size: 40
  }))), showAvatar && /*#__PURE__*/React.createElement(RHSControlListItem, null, /*#__PURE__*/React.createElement(Avatar, {
    baseUrl: baseUrl,
    menu: avatarMenuItems
  })), showShoppingCart && /*#__PURE__*/React.createElement(RHSControlListItem, null, /*#__PURE__*/React.createElement(ShoppingCart, {
    baseUrl: baseUrl,
    isLoggedIn: showAvatar,
    url: shoppingCartUrl
  })), showVeriSignLogo && /*#__PURE__*/React.createElement(RHSControlListItem, null, /*#__PURE__*/React.createElement(VeriSignLogo, null)));
};

var DesktopHeader = function DesktopHeader(_ref3) {
  var baseUrl = _ref3.baseUrl,
      menuItems = _ref3.menuItems,
      logoLink = _ref3.logoLink,
      logoAlt = _ref3.logoAlt,
      showSearch = _ref3.showSearch,
      loginUrl = _ref3.loginUrl,
      shoppingCartUrl = _ref3.shoppingCartUrl,
      isSearchActive = _ref3.isSearchActive,
      onSearchClick = _ref3.onSearchClick,
      menuHoverKey = _ref3.menuHoverKey,
      onMenuMouseEnter = _ref3.onMenuMouseEnter,
      onMenuMouseLeave = _ref3.onMenuMouseLeave,
      showTopRHSMenuItems = _ref3.showTopRHSMenuItems,
      showVeriSignLogo = _ref3.showVeriSignLogo,
      showLoginButton = _ref3.showLoginButton,
      showShoppingCart = _ref3.showShoppingCart,
      showAvatar = _ref3.showAvatar,
      avatarMenuItems = _ref3.avatarMenuItems,
      firstLevelLinks = _ref3.firstLevelLinks;
  return /*#__PURE__*/React.createElement(SCHeaderDesktop, null, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Column, {
    sm: 9,
    lg: 8
  }), /*#__PURE__*/React.createElement(Column, {
    sm: 3,
    lg: 4
  }, /*#__PURE__*/React.createElement(SCMenuItemList, {
    isInline: true
  }, showTopRHSMenuItems && /*#__PURE__*/React.createElement(DesktopTopRHSMenuItems, {
    baseUrl: baseUrl,
    items: firstLevelLinks
  })))), /*#__PURE__*/React.createElement(Row, {
    middle: "sm"
  }, /*#__PURE__*/React.createElement(SCFlexColumnAuto, null, /*#__PURE__*/React.createElement(SCMenuItemListPrimary, {
    isInline: true
  }, /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(Logo, {
    baseUrl: baseUrl,
    link: logoLink,
    alt: logoAlt
  })), /*#__PURE__*/React.createElement(DesktopMenu, {
    baseUrl: baseUrl,
    menuItems: menuItems,
    menuHoverKey: menuHoverKey,
    onMenuMouseEnter: onMenuMouseEnter,
    onMenuMouseLeave: onMenuMouseLeave
  }))), /*#__PURE__*/React.createElement(SCFlexColumnAutoEnd, null, /*#__PURE__*/React.createElement(DesktopRHSControls, {
    baseUrl: baseUrl,
    avatarMenuItems: avatarMenuItems,
    isSearchActive: isSearchActive,
    loginUrl: loginUrl,
    shoppingCartUrl: shoppingCartUrl,
    showAvatar: showAvatar,
    showLoginButton: showLoginButton,
    showSearch: showSearch,
    showShoppingCart: showShoppingCart,
    showVeriSignLogo: showVeriSignLogo,
    onSearchClick: onSearchClick
  })))));
};

export default DesktopHeader;